import GlobalMessage from './GlobalMessage-redux';

export default GlobalMessage;
